<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
  >
    <el-card class="">
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
        class="news-form"
      >
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="标题" prop="title">
              <el-input
                v-model="ruleForm.title"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="角色" prop="">
              <el-select
                ref="elSelect"
                v-model="agentRoleIdList"
                multiple
                clearable
                collapse-tags
                placeholder="请选择"
                @visible-change="checkUserList"
                style="width: 100%"
              >
                <el-option
                  v-for="item in AgentRoleInfoList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item
          label="选择人员"
          prop="agentUserInfoIdList"
          v-if="ruleForm.agentRoleIdList.length > 0"
        >
          <el-button type="primary" @click="userSelectBtn">选择人员</el-button>
        </el-form-item>

        <el-row :span="24" v-if="ruleForm.agentRoleIdList.length > 0">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label class="tabs">
              <el-table
                :data="ruleForm.agentUserInfoIdList"
                tooltip-effect="dark"
                style="width: 100%; margin: 20px 0"
                border
                max-height="800"
              >
                <el-table-column
                  prop="name"
                  label="姓名"
                  width="200"
                ></el-table-column>
                <el-table-column
                  prop="account"
                  label="手机"
                  width="200"
                ></el-table-column>
                <el-table-column
                  prop="campusName"
                  label="所属校区"
                ></el-table-column>
                <el-table-column
                  prop="roleName"
                  label="角色"
                  width="200"
                ></el-table-column>
                <el-table-column
                  prop="createTime"
                  label="操作"
                  align="center"
                  width="100"
                >
                  <template slot-scope="scope">
                    <span @click="deleteUserList(scope)" class="mainColor"
                      >删除</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="公告类型" prop="sendDest">
              <el-select
                v-model="ruleForm.sendDest"
                clearable
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in noticeType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="弹框推送" prop="isSend">
              <el-switch
                v-model="ruleForm.isSend"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item
          label="开通商品"
          prop="studentGroupId"
          v-if="ruleForm.sendDest == 3"
        >
          <el-button type="primary" @click="openaddFormVisible"
            >开通商品</el-button
          >
        </el-form-item>

        <el-row :span="24" v-if="ruleForm.sendDest == 3">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label class="tabs">
              <el-table
                ref="multipleTable"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                :data="subjectList"
                tooltip-effect="dark"
                style="width: 100%"
                max-height="800"
                border
              >
                <el-table-column
                  prop="name"
                  show-overflow-tooltip
                  label="商品"
                  align="center"
                >
                  <template slot-scope="row">
                    <el-row>
                      <el-col :span="8">
                        <span>
                          <img
                            style="margin-right: 10px"
                            height="60px"
                            width="100%"
                            :src="
                              row.row.logo
                                ? row.row.logo
                                : '../../../static/image/noImg.png'
                            "
                          />
                        </span>
                      </el-col>
                      <el-col :span="16">
                        <span
                          style="color: rgb(77, 148, 255); margin-left: 10px"
                          >{{ row.row.name }}</span
                        >
                        <span style="display: block; margin-left: 10px">
                          <span style="color: red">￥{{ row.row.price }}</span>
                          <span
                            style="
                              text-decoration: line-through;
                              color: rgb(162, 170, 188);
                            "
                            >￥{{ row.row.originalPrice }}</span
                          >
                        </span>
                      </el-col>
                    </el-row>
                  </template>
                </el-table-column>
                <el-table-column
                  width="150"
                  align="center"
                  prop="goodsCount"
                  label="数量"
                >
                  <template slot-scope="row">
                    <p style="color: red; font-weight: bold">
                      {{ row.row.goodsCount }}
                    </p>
                  </template>
                </el-table-column>

                <el-table-column
                  show-overflow-tooltip
                  width="150"
                  prop="agentPrice"
                  align="center"
                  label="开通价"
                >
                  <template slot-scope="row">
                    <span style="color: red; font-weight: bold"
                      >￥{{ row.row.agentPrice }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  prop="validDay"
                  width="150"
                  align="center"
                  label="有效期"
                >
                  <template slot-scope="row">{{
                    row.row.validDay ? row.row.validDay + '天' : '不限'
                  }}</template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  width="200"
                  prop="subjectCourseName"
                  align="center"
                  label="所属科目"
                ></el-table-column
                ><el-table-column
                  prop="createTime"
                  label="操作"
                  align="center"
                  width="100"
                >
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.readyBuy != 1"
                      @click="deleteList(scope.row)"
                      class="mainColor"
                      >删除</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="内容" prop="content">
          <quill-editor
            ref="quillEditor"
            v-model="ruleForm.content"
            class="addQuillEditor"
            :options="editorOption"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="submitFormLoading"
            @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button
            :loading="submitFormLoading"
            @click="handleClose('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
      <el-dialog
        title="添加商品"
        :visible.sync="addFormVisible"
        append-to-body
        width="855"
        left
        :close-on-click-modal="false"
      >
        <el-form :label-width="formLabelWidth">
          <el-row :gutter="24">
            <el-col :sm="8" :md="8" :lg="6">
              <el-cascader
                :show-all-levels="false"
                ref="tree"
                placeholder="请选择所属科目"
                collapse-tags
                @change="subjectChange"
                :options="subjectTreeList"
                :props="subjectTreeProps"
                clearable
              ></el-cascader>
            </el-col>
            <el-col :sm="8" :md="8" :lg="6">
              <el-select
                v-model="searchForm.type"
                clearable
                placeholder="请选择商品类型"
              >
                <el-option
                  v-for="item in goodsTypeList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :sm="8" :md="8" :lg="6">
              <el-input
                v-model="searchForm.name"
                placeholder="请输入商品名称"
              ></el-input>
            </el-col>
            <el-col :sm="5" :md="5" :lg="6" align="right">
              <el-button type="primary" @click="pageList2">查询</el-button>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :sm="24" :md="24" :lg="24">
              <el-table
                ref="multipleTables"
                v-loading="loading"
                height="400"
                :data="addFormVisibleList"
                tooltip-effect="dark"
                style="width: 100%; margin-top: 20px"
                @selection-change="selectionChange"
                border
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  prop="name"
                  width="370"
                  show-overflow-tooltip
                  label="商品"
                >
                  <template slot-scope="row">
                    <el-row>
                      <el-col :span="8">
                        <span>
                          <img
                            style="margin-right: 10px"
                            height="60px"
                            :src="
                              row.row.logo
                                ? row.row.logo
                                : '../../../static/image/noImg.png'
                            "
                          />
                        </span>
                      </el-col>
                      <el-col :span="16">
                        <span
                          style="color: rgb(77, 148, 255); margin-left: 10px"
                          >{{ row.row.name }}</span
                        >
                        <span style="display: block; margin-left: 10px">
                          <span style="color: red">￥{{ row.row.price }}</span>
                          <span
                            style="
                              text-decoration: line-through;
                              color: rgb(162, 170, 188);
                            "
                            >￥{{ row.row.originalPrice }}</span
                          >
                        </span>
                      </el-col>
                    </el-row>
                  </template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  width="140"
                  prop="agentPrice"
                  label="售价"
                >
                  <template slot-scope="row">
                    <span style="display: block">
                      <span style="color: red">￥{{ row.row.agentPrice }}</span>
                      <span
                        style="
                          text-decoration: line-through;
                          color: rgb(162, 170, 188);
                        "
                        >￥{{ row.row.price }}</span
                      >
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  prop="validDay"
                  width="100"
                  label="有效期"
                >
                  <template slot-scope="row">{{
                    row.row.validDay ? row.row.validDay + '天' : '不限'
                  }}</template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  width="250"
                  prop="subjectCourseName"
                  label="所属科目"
                ></el-table-column
              ></el-table>
              <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 20, 30, 40]"
                style="margin-top: 20px; text-align: right"
                :total="page.total"
                :page-size="page.pageSize"
                :current-page="page.pageNumber"
                @size-change="sizeChange"
                @current-change="currentChange"
              ></el-pagination>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="addFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="closeDialog">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
    <!------------------------------ 添加人员 ------------------------------>
    <el-dialog
      title="添加人员"
      :visible.sync="userFormVisible"
      append-to-body
      width="855"
      left
      :close-on-click-modal="false"
    >
      <el-form :label-width="formLabelWidth">
        <el-row :gutter="24">
          <el-col :sm="8" :md="8" :lg="6">
            <el-input
              v-model="userForm.name"
              placeholder="请输入姓名/手机"
            ></el-input>
          </el-col>
          <el-col :sm="5" :md="5" :lg="6" align="right">
            <el-button type="primary" @click="getUserList">查询</el-button>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-table
              ref="multipleUserTables"
              v-loading="loading"
              height="400"
              :data="userPage.rows"
              tooltip-effect="dark"
              style="width: 100%; margin-top: 20px"
              @selection-change="selectionUserChange"
              border
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                prop="name"
                label="姓名"
                width="150"
              ></el-table-column>
              <el-table-column
                prop="account"
                label="手机"
                width="200"
              ></el-table-column>
              <el-table-column
                prop="campusName"
                label="所属校区"
              ></el-table-column>
              <el-table-column prop="roleName" label="角色"></el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[10, 20, 30, 40]"
              style="margin-top: 20px; text-align: right"
              :total="userPage.total"
              :page-size="userPage.pageSize"
              :current-page="userPage.pageNumber"
              @size-change="sizeUserChange"
              @current-change="currentUserChange"
            ></el-pagination>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="userFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUserForm">确 定</el-button>
      </div>
    </el-dialog>
    <!------------------------------ 添加人员 ------------------------------>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import quillConfig from "../../upload/quill-config";
import { ImageDrop } from "quill-image-drop-module";
import ImageResize from "quill-image-resize-module";

Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);
export default {
  components: {
    quillEditor,
    quillConfig,
  },
  name: "send-news",
  props: {
    rowForm: Object,
  },
  data () {
    return {
      isShow: false,
      fullscreenLoading: false,
      editorOption: quillConfig,
      ruleForm: {
        title: "",
        content: "",
        agentIdList: [],
        isSend: 1,
        sendDest: "",
        agentRoleIdList: [],
        agentUserInfoIdList: [],
        goodsIdList: [],
      },

      subjectTreeList: [], //科目
      addFormVisibleList: [],
      addFormVisible: false,
      formLabelWidth: "80px",
      subjectTreeProps: {
        value: "id",
        label: "name",
        multiple: true,
        children: "children",
      },
      page: {
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      searchForm: {
        sell: 1,
        name: "",
        subjectIds: [],
      },
      // 添加人员------------------------------------------------------------------------
      userPage: {
        total: 0,
        rows: [],
        pageSize: 10,
        pageNumber: 1,
      },
      userForm: {
        name: "",
        pageNumber: "",
        pageSize: "",
      },
      userFormVisible: false,
      userSelectList: [],
      agentRoleIdList: [],
      // ------------------------------------------------------------------------添加人员
      loading: false,
      submitFormLoading: false,
      goodsTypeList: [],
      regionArray: [],
      subjectListAdd: [],
      subjectList: [],
      AgentRoleInfoList: [],
      noticeType: [
        {
          id: 1,
          name: "pc端",
        },
        {
          id: 2,
          name: "移动端",
        },
        {
          id: 3,
          name: "培训",
        },
      ],
      rules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" },
        ],
        sendDest: [{ required: true, message: "请选择公告类型", trigger: "change" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
    };
  },
  created () {
    this.getAgentRoleInfoList();
    if (this.rowForm != undefined) {
      this.ruleForm = this.rowForm;
    }
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.user;
    },
  },
  methods: {
    subjectChange (val) {
      if (val) {
        this.searchForm.subjectIds = [];
        val.forEach((item) => {
          this.searchForm.subjectIds.push(item[1]);
        });
      } else {
        this.searchForm.subjectIds = [];
      }
    },
    selectionChange (val) {
      this.subjectListAdd = val;
    },
    openaddFormVisible () {
      this.addFormVisible = true;
      this.pageList2();
      this.api
        .getSubjectTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
              }
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    closeDialog () {
      let that = this;
      this.totals = 0;
      let num = 0;
      this.subjectListAdd.forEach((item) => {
        let addSty = true;
        this.subjectList.forEach((items) => {
          if (items.id == item.id) {
            addSty = false;
          }
        });
        if (addSty) {
          let goods = JSON.parse(JSON.stringify(item));
          this.subjectList.push(goods);
        }
      });
      this.subjectList.forEach((e) => {
        this.$set(e, "goodsCount", 1);
        let n = Number(e.goodsCount);
        num += n;
        that.totals = that.totals + e.agentPrice * n;
      });
      this.addFormVisible = false;
    },
    // 移除
    deleteList (row) {
      this.subjectList.forEach((item, index) => {
        if (row.id == item.id) {
          this.totals = this.totals - item.agentPrice * item.goodsCount;
          this.subjectList.splice(index, 1);
          this.$message.success("移除成功");
        }
      });
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList2();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList2();
    },
    pageList2 () {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.agentId = this.loginData.agentId;
      this.api.goodsInfo
        .pageList(this.searchForm)
        .then((result) => {
          this.loading = false;
          this.addFormVisibleList = result.data.records;
          this.page.total = result.data.total;
          this.arrsSelect = [];
          this.addFormVisibleList.forEach((item, index) => {
            let sty = true;
            this.subjectList.forEach((items) => {
              if (item.id == items.id) {
                sty = false;
                this.$nextTick(() =>
                  this.$refs.multipleTables.toggleRowSelection(
                    this.addFormVisibleList[index]
                  )
                );
              }
            });
            if (!sty) {
              this.arrsSelect.push(item);
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 添加人员------------------------------------------------------------------------
    getUserList () {
      this.loading = true;
      this.userForm.roleIdList = this.ruleForm.agentRoleIdList;
      this.userForm.account = this.userForm.name;
      this.userForm.pageSize = this.userPage.pageSize;
      this.userForm.pageNumber = this.userPage.pageNumber;
      this.api.agentUserInfo
        .pageList(this.userForm)
        .then((result) => {
          this.userPage.rows = result.data.records;
          this.userPage.total = result.data.total;
          result.data.records.forEach((item) => {
            this.ruleForm.agentUserInfoIdList.forEach((_item) => {
              if (_item.id == item.id) {
                this.$nextTick(() => {
                  this.$refs.multipleUserTables.toggleRowSelection(item);
                });
              }
            });
          });
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sizeUserChange (pageSize) {
      this.userPage.pageSize = pageSize;
      this.getUserList();
    },
    currentUserChange (pageNumber) {
      this.userPage.pageNumber = pageNumber;
      this.getUserList();
    },
    userSelectBtn () {
      this.userSelectList = [];
      this.userFormVisible = true;
      this.userPage.rows = [];
      if (this.$refs.multipleUserTables) {
        this.$refs.multipleUserTables.clearSelection();
      }
      this.getUserList();
    },

    // 表格多选
    selectionUserChange (val) {
      this.userSelectList = val;
    },
    // 添加人员-确认按钮
    addUserForm () {
      this.userFormVisible = false;
      if (this.ruleForm.agentUserInfoIdList.length != 0) {
        this.userSelectList.forEach((item) => {
          if (!this.ruleForm.agentUserInfoIdList.some((_item) => _item.id == item.id)) {
            this.ruleForm.agentUserInfoIdList.push(item);
          }
        });
      } else {
        this.ruleForm.agentUserInfoIdList = this.userSelectList;
      }
    },
    // 删除人员
    deleteUserList (row) {
      this.ruleForm.agentUserInfoIdList.splice(row.$index, 1);
      this.$message.success("移除成功");
    },
    //重新选择角色，删除多余角色
    checkUserList (bol) {
      //下拉框关闭开始判断  true下拉框打开   false下拉框关闭
      if (!bol) {
        if (this.ruleForm.agentUserInfoIdList.length != 0) {
          let arr = [];
          this.ruleForm.agentUserInfoIdList.forEach((item) => {
            if (this.agentRoleIdList.some((_item) => _item == item.roleId)) {
              arr.push(item);
            }
          });
          this.ruleForm.agentUserInfoIdList = arr;
        }
        this.ruleForm.agentRoleIdList = this.agentRoleIdList;
      }
    },
    // ------------------------------------------------------------------------ 添加人员
    // 获取角色列表
    getAgentRoleInfoList () {
      let agentId = JSON.parse(localStorage.getItem("user")).agentId;
      this.api.notice.getAgentRoleInfoList({ agentId: agentId }).then((result) => {
        if (result.success) {
          this.AgentRoleInfoList = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    handleClose (formName) {
      this.$emit('handleClose', this.isShow)
      // this.$refs[formName].resetFields()
      // this.agentRoleIdList = ''
      // this.ruleForm.agentRoleIdList.length = 0
    },
    // 提交
    submitForm (formName) {
      if (this.ruleForm.sendDest === 3) {
        if (this.subjectList && this.subjectList.length > 0) {
          this.ruleForm.goodsIdList = [];
          this.subjectList.forEach((e) => {
            this.ruleForm.goodsIdList.push(e.id);
          });
          this.addNotice(formName);
        } else {
          this.$message.error("请选择商品！");
        }
      } else {
        this.addNotice(formName);
      }
    },
    // 添加公告
    addNotice (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          this.submitFormLoading = true;
          let obj = JSON.parse(JSON.stringify(this.ruleForm));
          let arr = [];
          obj.agentUserInfoIdList.forEach((item) => {
            arr.push(item.id);
          });
          obj.agentUserInfoIdList = arr;

          this.api.newsCenter
            .addNotice(obj)
            .then((result) => {
              if (result.success) {
                this.$message.success(result.message);
                // this.$refs[formName].resetFields();
                // this.$router.push({
                //   path: "/newsList",
                // });
                this.handleClose(formName)
              } else {
                this.$message.error(result.message);
              }
              this.submitFormLoading = false;
              this.fullscreenLoading = false;
            })
            .catch((error) => {
              this.submitFormLoading = false;
              this.fullscreenLoading = false;
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less">
.news-form {
  width: 101%;
  .addQuillEditor .ql-editor {
    height: 500px;
  }
}
.el-form-item__content {
  white-space: inherit;
}
.mb20 {
  margin-bottom: 20px;
}
.el-card {
  border: none;
  box-shadow: none;
}
.el-card.is-always-shadow {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/newsCenter/sendNews.vue